// extracted by mini-css-extract-plugin
var _1 = "EmailModalReplyForm-moduleformBody__MQCBl EmailCreationForm-moduleformBody__hZad9";
export { _1 as "formBody" }
